module.exports = __webpack_public_path__ + "img/34ec471.webp";